import React from "react";

export const Outstorage = () => {
  return <div>Outstorage</div>;
};

